export const adapterSearchArticles = (data) => {
  const articulos = data.articulos.map((article) =>
    adapterArticle(article || [], data)
  );

  return articulos;
};

export const adapterArticles = (data) => {
  
  const articulos = data.articulos.map((article) =>
    adapterArticle(article || [], data)
  );

  return articulos;
};

const readNumber = (value) => parseFloat(value) || 0;

export const adapterArticle = (ariticulos = {}, data = {}) => {
  return {
    sku: ariticulos?.sku || "",
    code: ariticulos?.codigoInterno,
    name: ariticulos?.nombre_Comercial || "",
    price: readNumber(ariticulos?.precio_SD),
    price1: readNumber(ariticulos?.precio_1),
    price2: readNumber(ariticulos?.precio_2),
    discountedPrice: readNumber(ariticulos?.precio_CD),
    discount: readNumber(ariticulos?.descuento_Porcentaje),
    shortDescription: ariticulos?.descripcion_p || "",
    image: [ariticulos?.imagen_1, ariticulos?.imagen_2].filter(Boolean) || [],
    stock: ariticulos?.cantidad || 0,
    images:
      [
        ariticulos.imagen_2,
        ariticulos.imagen_1,
        ariticulos.imagen_3,
        ariticulos.imagen_4,
        ariticulos.imagen_5,
      ].filter(Boolean)|| [],
    colors: adapterColors(data.colores) || [],
    brands: adapterBrands(data.marcas) || [],
    tags: adapterTags(data.etiquetas) || [],
    sizes: adapterSizes(data.tallas) || [],
    TagTallas: ariticulos.tagTallas || null,
    TagColores: ariticulos.tagColores || null,
    TagMarcas: ariticulos.tagMarcas || null,
    Tagetiquetas: ariticulos.tagetiquetas || null,
    TagFacetas: JSON.parse(ariticulos.tagFacetas) || null
  };
};

export const adapterArticleDetail = (data) => {
  
  function adapterArticle(relacionados) {
    // Ensure this function is properly defined to handle related products
    return relacionados.map((item) => ({
      id: item.idArticulo,
      sku: item.sku,
      name: item.nombre_Comercial,
      description: item.descripcion_p,
      code: item.codigoInterno,
      price: readNumber(item.precio_SD),
      price1: readNumber(item.precio_1),
      price2: readNumber(item.precio_2),
      discount: readNumber(item.descuento_Porcentaje),
      discountedPrice: readNumber(item.precio_CD),
      image: [item.imagen_1, item.imagen_2].filter(Boolean),
    }));
  }
  function adapterVariants(variants) {
    
    // Mapeo de orden de tallas según el backend
    const tallaOrderMap = (data.talla || []).reduce((acc, talla, index) => {
      acc[talla.idTalla] = index;
      return acc;
    }, {});
  
    
    // Adaptar y ordenar
    return variants
      .map((item) => ({
        id: item.idArticulo,
        sku: data.sku || item.sku,
        name: item.nombre_Comercial,
        description: item.descripcion_p,
        code: item.codigoInterno,
        price: readNumber(item.precio_SD),
        price1: readNumber(item.precio_1),
        price2: readNumber(item.precio_2),
        discount: readNumber(item.descuento_Porcentaje),
        discountedPrice: readNumber(item.precio_CD),
        image: [item.imagen_1, item.imagen_2].filter(Boolean),
        color: item.color,
        idColor: item.idColor,
        size: item.talla,
        idSize: item.idTalla,
        images: [
          item.imagen_1,
          item.imagen_2,
          item.imagen_3,
          item.imagen_4,
          item.imagen_5,
        ].filter(Boolean),
        stock: item.cantidad,
      }))
      .sort((a, b) => {
        const indexA = tallaOrderMap[a.idSize] ?? Infinity;
        const indexB = tallaOrderMap[b.idSize] ?? Infinity;
        return indexA - indexB;
      });
  }
  
  function adapterSizes(sizes) {
    // Ensure this function is properly defined to handle related products
    return sizes.map((item) => ({
      id: item.idTalla,
      name: item.nombre,
      stock: item.cantidad,
    }));
  }
  function adapterColors(colors) {
    // Ensure this function is properly defined to handle related products
    return colors.map((item) => ({
      id: item.idColor,
      name: item.nombre,
      colorRGB: item.codigo_RGB,
      colorHex: item.codigo_HEX,
      stock: item.cantidad || 0,
    }));
  }

  return { 
    id: data.articulo.sku || "",
    sku: data.articulo.sku || "",
    name: data.articulo.nombre_Comercial || "",
    code: data.articulo.codigoInterno,
    price: readNumber(data.articulo.precio_SD),
    price1: readNumber(data.articulo.precio_1),
    price2: readNumber(data.articulo.precio_2),
    discount: readNumber(data.articulo.descuento_Porcentaje),
    discountedPrice: readNumber(data.articulo.precio_CD),
    new: !!data.articulo.new, // Cast to boolean if `new` flag exists

    // Assuming that stock needs to be calculated if 'stock' is not available in 'variantes'
    stock: data.variantes.reduce(
      (total, variante) => total + (variante.cantidad || 0),
      0
    ),

    shortDescription: data.articulo.descripcion_p || "",
    fullDescription: data.articulo.descripcion_g || "", // Assuming 'Descripcion_g' exists
    category: [], // Populate this if category data becomes available
    tag: [], // Populate this if tag data becomes available
    image: [data.articulo.imagen_1, data.articulo.imagen_2].filter(Boolean),
    images: [
      data.articulo.imagen_1,
      data.articulo.imagen_2,
      data.articulo.imagen_3,
      data.articulo.imagen_4,
      data.articulo.imagen_5,
    ].filter(Boolean).sort((a, b) => {
      const numA = parseInt(a.match(/\d+/)?.[0] || 0, 10);
      const numB = parseInt(b.match(/\d+/)?.[0] || 0, 10);
      return numA - numB;
    }),

    sizes: adapterSizes(data.talla || []),
    colors: adapterColors(data.color || []),
    variation: adapterVariants(data.variantes || []),
    relatedProducts: adapterArticle(data.relacionados || []),
  };
};

export const adapterNewArrivals = (data) => {  
  const articulos = data.map((article) => adapterNewArrival(article || []));
  return articulos;
};

export const adapterNewArrival = (data) => {
  return {
    id: data.idArticulo,
    code: data.CodigoInterno,
    sku: data.sku,
    name: data.nombre_Comercial,
    shortDescription: data.descripcion_p,
    price: readNumber(data.precio_SD),
    price1: readNumber(data.precio_1),
    price2: readNumber(data.precio_2),
    discount: readNumber(data.descuento_Porcentaje),
    discountedPrice: readNumber(data.precio_CD),
    image: data.imagen_1,
    images: [data.imagen_1],
    stock: data.cantidad,
  };
};

export const adapterFilters = (data) => {
  return {
    categories: data.categorias || [],
    tags: adapterTags(data.etiquetas) || [],
    brands: adapterBrands(data.marcas) || [],
    colors: adapterColors(data.colores) || [],
    sizes: adapterSizes(data.tallas) || [],
  };
};

export const adapterSizes = (data) => {
  return data.map((item) => {
    return {
      id: item.idSize,
      name: item.nombre,
    };
  });
};

export const adapterColors = (data) => {
  return data.map((item) => {
    return {
      id: item.idColor,
      name: item.nombre,
      hex: item.codigo_HEX,
      rgb: item.codigo_RGB,
    };
  });
};

export const adapterBrands = (data) => {
  return data.map((item) => {
    return {
      id: item.idFabricante,
      name: item.nombre,
    };
  });
};

export const adapterTags = (data) => {
  return data.map((item) => {
    return {
      tag: item.etiqueta,
    };
  });
};
